import React from "react";
import "./customBtn.css";

const CustomBtn = ({ text, color }) => {
  return (
    <div className="customBtnContainer">
      <p>{text}</p>
    </div>
  );
};

export default CustomBtn;
